
import api from 'frontend/api';

export default {
	async fetchCartItems({ commit })
	{
		var result = await api.get('/cart');
		commit('setCartItems', result.data.cart.items)
		commit('setCartTotals', { total: result.data.cart.total });
	}
}